// src/App.js (Updated with smooth scrolling navigation)
import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import Banking from './Banking';
import Consulting from './Consulting';
import Staffing from './Staffing';

function Home() {
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'banking', 'consulting', 'staffing'
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

const images = [
  "https://media.istockphoto.com/id/2143222197/photo/businesses-use-smartphones-with-online-banking-digital-technology-mobile-banking-for-shopping.jpg?s=612x612&w=0&k=20&c=4AILv1uG4sb5beNLjGQVRGx-_QPeVK5EM4yNNSoczAI=",
  "https://www.valuecoders.com/wp-content/uploads/2023/08/Frame-3.png.webp",
  "https://thumbs.dreamstime.com/b/replacing-departing-employee-new-one-firing-existing-employee-new-one-replacing-departing-employee-new-422871367.jpg",
  "https://t3.ftcdn.net/jpg/01/19/91/02/360_F_119910257_OCrWhZF10uk4CGFhGtlGP60kf5BOifyx.jpg",
  "https://img1.wsimg.com/isteam/getty/1393059175/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:1160,h:749",
  "https://img1.wsimg.com/isteam/getty/1432521278"
];


  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);


  // Refs for sections
  const heroRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleBankingClick = () => setCurrentPage('banking');
  const handleConsultingClick = () => setCurrentPage('consulting');
  const handleStaffingClick = () => setCurrentPage('staffing');
  const handleBackToHome = () => setCurrentPage('home');

  // Conditional render for pages
  if (currentPage === 'banking') return <Banking onBack={handleBackToHome} />;
  if (currentPage === 'consulting') return <Consulting onBack={handleBackToHome} />;
  if (currentPage === 'staffing') return <Staffing onBack={handleBackToHome} />;

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you! Your message has been sent.');
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="bg-white min-h-screen text-black font-sans">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white shadow-md px-6 py-4 border-b border-gray-200">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => scrollToSection(heroRef)}>
            <img 
              src="/mylogo.jpeg" 
              alt="Brain Serve Logo" 
              className="h-8 md:h-10 w-auto hover:opacity-80 transition-opacity" 
              onError={(e) => { // Fallback to text if image fails
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <span className="hidden sm:flex text-2xl font-bold">
              <span className="text-red-500">Brain</span>Serve
            </span>
          </div>
          <ul className="hidden md:flex space-x-8">
            {[
              { label: 'Home', onClick: () => scrollToSection(heroRef) },
              { label: 'Services', onClick: () => scrollToSection(servicesRef) },
              { label: 'About', onClick: () => scrollToSection(aboutRef) },
              { label: 'Contact', onClick: () => scrollToSection(contactRef) }
            ].map((item) => (
              <motion.li 
                key={item.label} 
                className="hover:text-red-500 cursor-pointer transition-colors font-medium"
                onClick={item.onClick}
                whileHover={{ scale: 1.05 }}
              >
                {item.label}
              </motion.li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section ref={heroRef} className="relative h-screen flex items-center justify-center">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center md:text-left"
          >
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              Business Advisory
              <span className="text-red-500 block">Services</span>
            </h1>
            <p className="text-xl mb-8 text-gray-600 max-w-lg">Where Finance Meets Opportunity – Tailored Banking, Global Consulting, and Elite Staffing.</p>
            <button
  onClick={() => scrollToSection(servicesRef)}
  className="bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold"
>
  Discover More
</button>

          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="w-full h-96 bg-gray-100 rounded-2xl flex items-center justify-center shadow-md">
              {/* Placeholder for hero image */}
              <img src='https://cms.dmpcdn.com/news/2020/05/11/8db38e40-936b-11ea-90c4-73c466dc4865_original.jpg'></img>
            </div>
          </motion.div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent"></div>
      </section>

{/* Carousol */}
<section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-3xl font-semibold text-center mb-12">
          Areas We Serve
        </h2>

        <div className="relative overflow-hidden rounded-xl shadow-lg">
          <div
            className="flex transition-transform duration-700"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="carousel"
                className="w-full h-[420px] object-cover flex-shrink-0"
              />
            ))}
          </div>

          {/* Navigation dots */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-3">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-3 h-3 rounded-full ${
                  current === i ? "bg-red-600" : "bg-white/70"
                }`}
              />
            ))}
          </div>
        </div>

      </div>
    </section>


      {/* Services Section */}
      <section ref={servicesRef} className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <motion.h2 
            className="text-4xl font-bold text-center mb-16 text-black"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Our Core Services
          </motion.h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: '🏦', title: 'Banking Solutions', desc: 'From homeownership to business expansion, our loans pave the way—home, educational, car, and business financing with ease.', color: 'border-red-500', onClick: handleBankingClick },
              { icon: '🌍', title: 'Overseas Consulting', desc: 'Seamless overseas journeys: Expertise in visas, relocation, and global strategies you can trust.', color: 'border-blue-500', onClick: handleConsultingClick },
              { icon: '👥', title: 'Staffing Services', desc: 'Precision matching for peak performance teams—connecting talent to opportunities that drive success.', color: 'border-green-500', onClick: handleStaffingClick }
            ].map((service, index) => (
              <motion.div
                key={service.title}
                className={`bg-white rounded-2xl p-8 border border-gray-200 hover:border-red-500 transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer ${service.onClick ? 'hover:bg-red-50' : ''}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10, scale: 1.02 }}
                onClick={service.onClick}
              >
                <div className={`w-16 h-16 ${service.color} border-4 rounded-full flex items-center justify-center mx-auto mb-6 bg-white`}>
                  <span className="text-2xl">{service.icon}</span>
                </div>
                <h3 className="text-2xl font-semibold mb-4 text-center text-black">{service.title}</h3>
                <p className="text-gray-600 text-center mb-6">{service.desc}</p>
                <button className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-xl transition duration-300">
                  Explore
                </button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section ref={aboutRef} className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <motion.h2 
            className="text-4xl font-bold mb-8 text-black"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Why Choose Brain Serve?
          </motion.h2>
          <motion.p 
            className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            We're more than a service provider—we're your strategic ally. Blending cutting-edge banking, insightful overseas consulting, and dynamic staffing, 
            Brain Serve has empowered thousands to turn ambitions into achievements. With a commitment to integrity and innovation, we're here to serve your unique journey.
          </motion.p>
        </div>
      </section>

      {/* Contact Section */}
      <section ref={contactRef} className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <motion.h2 
            className="text-4xl font-bold text-center mb-16 text-black"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Let's Connect
          </motion.h2>
          <div className="grid md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="text-2xl font-semibold mb-4 text-black">Quick Contact</h3>
              <p className="text-gray-600 mb-4">Email: admin@brainserve.in</p>
              <p className="text-gray-600 mb-8">Phone: +91 9063191650</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-black placeholder-gray-400 focus:border-red-500 focus:outline-none transition"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-black placeholder-gray-400 focus:border-red-500 focus:outline-none transition"
                  required
                />
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-black placeholder-gray-400 focus:border-red-500 focus:outline-none transition"
                  required
                />
                <button type="submit" className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-xl font-semibold transition">
                  Send
                </button>
              </form>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-white rounded-2xl p-8 shadow-sm h-fit border border-gray-200"
            >
              <h3 className="text-2xl font-semibold mb-4 text-black">Our Vision</h3>
              <p className="text-gray-600 mb-6">Empowering dreams through smart finance and global connections.</p>
              {/* Location Map Embed */}
              <div className="mb-4">
                <h4 className="text-lg font-semibold mb-2 text-black">Our Location</h4>
                <p className="text-sm text-gray-500 mb-4">Brain Serve <br />1st Floor, H, No: 1, Kavuri Hills Rd, CBI Colony, Madhapur, Hyderabad, Telangana 500033</p>
              </div>
              <div className="w-full h-64 rounded-xl overflow-hidden shadow-md">
               
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3806.4638267944765!2d78.39670029999999!3d17.437500399999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDI2JzE1LjAiTiA3OMKwMjMnNDguMSJF!5e0!3m2!1sen!2sin!4v1767006320767!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Brain Serve Location Map"
                ></iframe>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-8 text-center text-gray-500 border-t border-gray-200">
        <p>&copy; 2025 Brain Serve. All rights reserved. | Fueling Futures, One Step at a Time.</p>
      </footer>
    </div>
  );
}

export default Home;